import { apiClient } from 'api/apiClient';

const RESOURCE = '/projects';

export interface IProject {
	ssmA_TimeStamp: string;
	id: number;
	clientName: string;
	numAttachments: number;
	proj: string;
	projn: string;
	client: string;
	dateopened: string;
	manager: string;
	taxc: string;
	billaddrtype: number;
	markupmerc: number;
	markupdesign: number;
	markupfreight: number;
	markupinstall: number;
	markuplabor: number;
	markupother: number;
	markupgp: boolean;
	clientdep: number;
	clientinvterms: string;
	cldpsalestax: boolean;
	indepositmerc: boolean;
	indepositdesign: boolean;
	indepositfreight: boolean;
	indepositinstall: boolean;
	indepositlabor: boolean;
	indepositother: boolean;
	finchg: boolean;
	posidemark: string;
	locinsidemark: boolean;
	alwaysact: boolean;
	notes: string;
	notesrtf: string;
	singleitemprop: boolean;
	singleiteminv: boolean;
	singleitempo: boolean;
	manual: boolean;
	propshowrem: boolean;
	propremarks: string;
	propremarksrtf: string;
	propremsep: boolean;
	propshowtax: boolean;
	propsupunit: boolean;
	propunit2dec: boolean;
	propsuploc: boolean;
	proptitle: string;
	propsupname: boolean;
	propsupnum: boolean;
	propnameasnum: boolean;
	propshowsite: boolean;
	propprojcode: boolean;
	invshowrem: boolean;
	invremarks: string;
	invremarksrtf: string;
	invremsep: boolean;
	invsupunit: boolean;
	invunit2dec: boolean;
	invsuploc: boolean;
	invshowsite: boolean;
	invshowshipto: boolean;
	invprojcode: boolean;
	siteaddrtype: number;
	taxm: boolean;
	taxd: boolean;
	taxf: boolean;
	taxi: boolean;
	taxl: boolean;
	taxo: boolean;
	usediscountmerc: number;
	usediscountdesign: number;
	usediscountfreight: number;
	usediscountinstall: number;
	usediscountlabor: number;
	usediscountother: number;
	propmercdesc: string;
	propdesigndesc: string;
	propfreightdesc: string;
	propinstalldesc: string;
	proplabordesc: string;
	propotherdesc: string;
	propmercstyle: number;
	propdesignstyle: number;
	propfreightstyle: number;
	propinstallstyle: number;
	proplaborstyle: number;
	propotherstyle: number;
	invmercdesc: string;
	invdesigndesc: string;
	invfreightdesc: string;
	invinstalldesc: string;
	invlabordesc: string;
	invotherdesc: string;
	invmercstyle: number;
	invdesignstyle: number;
	invinstallstyle: number;
	invfreightstyle: number;
	invlaborstyle: number;
	invotherstyle: number;
	invpricemodem: number;
	invpricemoded: number;
	invpricemodef: number;
	invpricemodei: number;
	invpricemodel: number;
	invpricemodeo: number;
	shipaddrtype: number;
	pomercstyle: number;
	podesignstyle: number;
	pofreightstyle: number;
	poinstallstyle: number;
	polaborstyle: number;
	pootherstyle: number;
	pomercdesc: string;
	podesigndesc: string;
	pofreightdesc: string;
	poinstalldesc: string;
	polabordesc: string;
	pootherdesc: string;
	closeddt: string;
	pofulldesc: boolean;
	shiptoaddrtype: number;
	designer: string;
	potitle: string;
	invshowpayments: boolean;
	blanklocsort: number;
	invsupplement: boolean;
	timeaddtoscat: boolean;
	timeloccode: string;
	timescatcode: string;
	invshowtimedetails: boolean;
	clientorder: string;
	shipto: string;
	bypasswip: boolean;
	pofaxprefix: string;
	poagentfor: boolean;
	propshowfeecost: boolean;
	invshowfeecost: boolean;
	order: boolean;
	ordquotedt: string;
	ordackdt: string;
	ordrevdt: string;
	ordmercdesc: string;
	orddesigndesc: string;
	ordfreightdesc: string;
	ordinstalldesc: string;
	ordlabordesc: string;
	ordothersdesc: string;
	ordmercstyle: number;
	orddesignstyle: number;
	ordfreightstyle: number;
	ordinstallstyle: number;
	ordlaborstyle: number;
	ordothersstyle: number;
	ordremarks: string;
	ordremarksrtf: string;
	ordshowtaxo: boolean;
	ordremsep: boolean;
	ordsupunit: boolean;
	ordunit2dec: boolean;
	ordsuploc: boolean;
	ordtitleo: string;
	ordshowtaxq: boolean;
	ordshowsite: boolean;
	ordtitleq: string;
	ordremarksq: string;
	ordremarksqrtf: string;
	ordremarkso: string;
	ordremarksortf: string;
	pictnum: number;
	tempquoteremsrtf: string;
	autom: boolean;
	autod: boolean;
	autof: boolean;
	autoi: boolean;
	autol: boolean;
	autoo: boolean;
	orddeldt: string;
	ordinvdt: string;
	ordinvnum: number;
	siftracknum: string;
	propsuppressdes: boolean;
	timebillingtier: number;
	onepo: boolean;
	oneproposal: boolean;
	invemail: boolean;
	poemail: boolean;
	propemail: boolean;
	ordemail: boolean;
	budgettol: number;
	budgetwarn: number;
	budgett: number;
	invshowtbtime: boolean;
	haswebclient: boolean;
	showweb: boolean;
	blanklocpgbreakbefore: boolean;
	sitesameasbill: boolean;
	timecreateitem: number;
	timeonlydated: boolean;
	timeautocreate: boolean;
	budgettoverride: boolean;
	delremarks: string;
	delremarksrtf: string;
	clientId: number;
	lastOrderNotificationId: number;
	lastQuoteNotificationId: number;
	orderFileId: string;
	quoteFileId: string;
	requestedRetainerAmount: number;
	lastRetainerRequestNotificationId: number;
	clientPortalEnabled: boolean;
	clientPortalLogoUrl: string;
	clientPortalColorPrimary: string;
	clientPortalColorSecondary: string;
	clientPortalShowProjectBudget: boolean;
	clientPortalAllowSendMessage: boolean;
	clientPortalMessageRecipient: string;
	clientPortalItemsApproval: boolean;
	clientPortalProposalsApproval: boolean;
	clientPortalProposalsRequireSignature: boolean;
}

export const getProjects = async (filter?: string): Promise<IProject[]> => {
	const { data } = await apiClient.get(`${RESOURCE}${filter}`.trim());

	return data;
};
